import React from 'react';
import s from './Invite.css';
import withStyles from "isomorphic-style-loader/withStyles";
import Container from "@material-ui/core/Container";
import HeadMessage from "../../components/Common/HeadMessage/HeadMessage";
import Button from "@material-ui/core/Button";
import ChipInput from 'material-ui-chip-input'
import CardGiftcard from '@material-ui/icons/CardGiftcard';
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import Link from "../../components/Link";
import me from "../../data/fetch/me";
import ga from "../../utils/ga";
import LinkIcon from '@material-ui/icons/Link';
import CopyLinkDialog from "./CopyLinkDialog";

class Invite extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            user: this.props.user,
            chips: [],
            showCopyLink: false
        };
    }

    async login() {
        const self = this;

        return new Promise((resolve, reject) => {
        // Надо авторизоваться
        let loginWindow = window.open('/login/google/close', 'example', 'width=500,height=600');
            ga('send', 'event', 'Invite', 'login', 'start');

            let timer = setInterval(async function() {
                if(loginWindow.closed) {
                    clearInterval(timer);
                    const user = await me(self.props.fetch);

                    if (user.id) {
                        ga('send', 'event', 'Invite', 'login', 'success');
                        self.setState({ user: user });
                    } else {
                        ga('send', 'event', 'Invite', 'login', 'no');
                    }

                    resolve(user);
                }
            }, 100);
        });
    }

    async send() {
        const self = this;

        if (!this.state.user) {
            return this.login().then((user) => {
                if (user.id) {
                    self.send();
                } else {
                    alert('Sign in to send invites.');
                }
            });
        }

        this.setState({ loading: true });

        const invites = this.state.chips.map((chip) => { return `{inviteEmail: "${chip}"`; }).join(',');

        ga('send', 'event', 'Invite', 'send', invites.length);

        const resp = await this.props.fetch('/graphql', {
            body: JSON.stringify({
                query: 'mutation Send($invites:[InviteInput]) {sendInvites(invites: $invites)  {inviteEmail,status}}',
                variables: {
                    invites: this.state.chips.map((chip) => { return { inviteEmail: chip }; })
                }
            }),
        });


        const sended = await resp.json();
        this.setState({ loading: false });

        if (!sended.data || !sended.data.sendInvites) {
            ga('send', 'event', 'Invite', 'error');
            return alert('Error. Try one more time, or later');
        }

        if (sended.data.sendInvites.length) {
            alert(sended.data.sendInvites.map((i) => i.inviteEmail + ' - ' + i.status + '\r\n'));

            const sentCount = sended.data.sendInvites.filter((invite) => invite.status === 'invite sent').length;

            if (sentCount) {
                ga('send', 'event', 'Invite', 'sent', sentCount);
                window.open('/invited', '_self');
            }
        } else {
            ga('send', 'event', 'Invite', 'no-valid');
            alert('No email was sended. Check your list');
        }
    }

    showCopyLink() {
        const self = this;

        function openWindow() {
            self.setState({ showCopyLink: true });
            ga('send', 'event', 'Invite', 'copyLink', 'success');
        }

        if (!this.state.user) {
            return this.login().then((user) => {
                if (user.id) {
                    openWindow();
                } else {
                    ga('send', 'event', 'Invite', 'copyLink', 'no-login');
                    alert('Sign in to create your personal referral link');
                }
            });
        } else {
            openWindow();
        }
    }

    render() {
        return (
            <div className={s.root}>
                <Container>
                    <HeadMessage>
                        <h2>Get up to <span>20 free widgets</span></h2>
                    </HeadMessage>

                    <CardGiftcard style={{ fontSize: 200, color: 'rgba(255, 158, 0, 0.83)' }} />

                    <h5 style={{ fontSize: 16, lineHeight: '24px' }}>Invite your friends to join New Tab Studio, and for each one who installs New Tab Studio<br/>
                        we'll give you <strong>2 free widgets forever</strong>. If you need even more widgets, <Link to={'/pro'}>upgrade your account</Link></h5>

                    <div style={{ width: 400, display: 'inline-block' }}>
                        <ChipInput
                            defaultValue={[]}
                            inputRef={(ref) => ref && ref.focus()}
                            onChange={(chips) => { this.setState({chips: chips})}}
                            InputProps={{
                                style: { width: 300 }
                            }}
                            placeholder={'Email addresses'}
                            fullWidth
                        />
                    </div>

                    <br/><br/>

                    {!this.state.loading && <Button className={s.bigButton} color={'primary'} size={'large'} variant={'contained'} onClick={this.send.bind(this)}>Send</Button>}
                    {this.state.loading && <LinearProgress style={{ width: 300, margin: '0 auto' }}/>}

                    <div className={s.moreWays}>
                        <h1>More ways to invite your friends</h1>

                        <Button onClick={() => this.showCopyLink()} className={s.whiteButton} size={'large'} variant={'contained'}><LinkIcon />&nbsp;Copy link</Button>

                        <hr style={{ margin: 30 }}/>

                        Once you've invited friends, you can view the&nbsp;
                        {this.state.user && <Link to={'/invited'}>status of your referrals</Link>}
                        {!this.state.user && <span>status of your referrals</span>}.
                    </div>

                    <CopyLinkDialog open={this.state.showCopyLink} onClose={() => this.setState({ showCopyLink: false })} />
                </Container>
            </div>
        );
    }
}

export default withStyles(s)(Invite);